import React from "react";

const ProgressLevelBar = ({ level }) => {
  return (
    <div id="progress-level-bar" className="level-bar">
      <ul className="step-menu">
        <li role="button" className={level === 0 ? "current" : "complete"}>
          Submit Registration
        </li>
        <li
          role="button"
          className={level === 1 ? "current" : level > 1 ? "complete" : ""}
        >
          Process Registration
        </li>
        <li
          role="button"
          className={level === 2 ? "current" : level > 2 ? "complete" : ""}
        >
          Orientation Ready
        </li>
        <li role="button" className={level === 3 ? "complete" : ""}>
          Enrollment Complete
        </li>
      </ul>
    </div>
  );
};

export default ProgressLevelBar;
